export const filterNullish = array => {
  if (!Array.isArray(array)) {
    return []
  }

  const filteredArray = array.filter(item => item)

  return filteredArray
}
